import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MbsPopupType, MbsUiKitModule, ModalComponent } from 'mbs-ui-kit';
import { CommonModule } from "@angular/common";
import { I18NextModule } from "angular-i18next";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AbilityModule } from "ability";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  templateUrl: './offline-edit-version-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports:[CommonModule, I18NextModule, FormsModule, ReactiveFormsModule, MbsUiKitModule, AbilityModule, NgbTooltipModule]
})
export class OfflineEditVersionModalComponent {
  public readonly alertType = MbsPopupType;

  @ViewChild(ModalComponent, { static: true }) modal: ModalComponent;

  constructor() {}

  handleClose() {
    this.modal.close();
  }
}
